import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Entry2xmjmyutzoq3p as Entry } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MAP_getInstance3e78m6vf98i66 as MAP_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.k28_1 = key;
        this.l28_1 = value;
      }
      m3() {
        return this.k28_1;
      }
      n3() {
        return this.l28_1;
      }
      toString() {
        return 'MapEntry(key=' + toString(this.k28_1) + ', value=' + toString(this.l28_1) + ')';
      }
      hashCode() {
        var result = this.k28_1 == null ? 0 : hashCode(this.k28_1);
        result = imul(result, 31) + (this.l28_1 == null ? 0 : hashCode(this.l28_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapEntry()))
          return false;
        if (!equals(this.k28_1, other.k28_1))
          return false;
        if (!equals(this.l28_1, other.l28_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [Entry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var MapEntrySerializerClass;
function MapEntrySerializer() {
  if (MapEntrySerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.o28_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], ($this$buildSerialDescriptor) => {
          $this$buildSerialDescriptor.r1n('key', keySerializer.b1n());
          $this$buildSerialDescriptor.r1n('value', valueSerializer.b1n());
          return Unit_instance;
        });
      }
      b1n() {
        return this.o28_1;
      }
      p28(_this__u8e3s4) {
        return _this__u8e3s4.m3();
      }
      q28(_this__u8e3s4) {
        return this.p28((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r28(_this__u8e3s4) {
        return _this__u8e3s4.n3();
      }
      s28(_this__u8e3s4) {
        return this.r28((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      t28(key, value) {
        return new (MapEntry())(key, value);
      }
    }
    initMetadataForClass($, 'MapEntrySerializer');
    MapEntrySerializerClass = $;
  }
  return MapEntrySerializerClass;
}
var PairSerializerClass;
function PairSerializer() {
  if (PairSerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        tmp.z28_1 = buildClassSerialDescriptor('kotlin.Pair', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.r1n('first', keySerializer.b1n());
          $this$buildClassSerialDescriptor.r1n('second', valueSerializer.b1n());
          return Unit_instance;
        });
      }
      b1n() {
        return this.z28_1;
      }
      a29(_this__u8e3s4) {
        return _this__u8e3s4.bf_1;
      }
      q28(_this__u8e3s4) {
        return this.a29(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      b29(_this__u8e3s4) {
        return _this__u8e3s4.cf_1;
      }
      s28(_this__u8e3s4) {
        return this.b29(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      t28(key, value) {
        return to(key, value);
      }
    }
    initMetadataForClass($, 'PairSerializer');
    PairSerializerClass = $;
  }
  return PairSerializerClass;
}
function decodeSequentially($this, composite) {
  var a = composite.f1s($this.f29_1, 0, $this.c29_1);
  var b = composite.f1s($this.f29_1, 1, $this.d29_1);
  var c = composite.f1s($this.f29_1, 2, $this.e29_1);
  composite.t1r($this.f29_1);
  return new (Triple())(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.j1s($this.f29_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.f1s($this.f29_1, 0, $this.c29_1);
        break;
      case 1:
        b = composite.f1s($this.f29_1, 1, $this.d29_1);
        break;
      case 2:
        c = composite.f1s($this.f29_1, 2, $this.e29_1);
        break;
      default:
        throw SerializationException().w1o('Unexpected index ' + index);
    }
  }
  composite.t1r($this.f29_1);
  if (a === get_NULL())
    throw SerializationException().w1o("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException().w1o("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException().w1o("Element 'third' is missing");
  return new (Triple())(a, b, c);
}
var TripleSerializerClass;
function TripleSerializer() {
  if (TripleSerializerClass === VOID) {
    class $ {
      constructor(aSerializer, bSerializer, cSerializer) {
        this.c29_1 = aSerializer;
        this.d29_1 = bSerializer;
        this.e29_1 = cSerializer;
        var tmp = this;
        tmp.f29_1 = buildClassSerialDescriptor('kotlin.Triple', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.r1n('first', this.c29_1.b1n());
          $this$buildClassSerialDescriptor.r1n('second', this.d29_1.b1n());
          $this$buildClassSerialDescriptor.r1n('third', this.e29_1.b1n());
          return Unit_instance;
        });
      }
      b1n() {
        return this.f29_1;
      }
      g29(encoder, value) {
        var structuredEncoder = encoder.s1r(this.f29_1);
        structuredEncoder.k1t(this.f29_1, 0, this.c29_1, value.gu_1);
        structuredEncoder.k1t(this.f29_1, 1, this.d29_1, value.hu_1);
        structuredEncoder.k1t(this.f29_1, 2, this.e29_1, value.iu_1);
        structuredEncoder.t1r(this.f29_1);
      }
      c1n(encoder, value) {
        return this.g29(encoder, value instanceof Triple() ? value : THROW_CCE());
      }
      d1n(decoder) {
        var composite = decoder.s1r(this.f29_1);
        if (composite.i1s()) {
          return decodeSequentially(this, composite);
        }
        return decodeStructure(this, composite);
      }
    }
    initMetadataForClass($, 'TripleSerializer', VOID, VOID, [KSerializer()]);
    TripleSerializerClass = $;
  }
  return TripleSerializerClass;
}
var KeyValueSerializerClass;
function KeyValueSerializer() {
  if (KeyValueSerializerClass === VOID) {
    class $ {
      constructor(keySerializer, valueSerializer) {
        this.u28_1 = keySerializer;
        this.v28_1 = valueSerializer;
      }
      w28(encoder, value) {
        var structuredEncoder = encoder.s1r(this.b1n());
        structuredEncoder.k1t(this.b1n(), 0, this.u28_1, this.q28(value));
        structuredEncoder.k1t(this.b1n(), 1, this.v28_1, this.s28(value));
        structuredEncoder.t1r(this.b1n());
      }
      c1n(encoder, value) {
        return this.w28(encoder, value);
      }
      d1n(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.b1n();
        var composite = decoder.s1r(descriptor);
        var tmp$ret$1;
        $l$block: {
          if (composite.i1s()) {
            var key = composite.f1s(this.b1n(), 0, this.u28_1);
            var value = composite.f1s(this.b1n(), 1, this.v28_1);
            tmp$ret$1 = this.t28(key, value);
            break $l$block;
          }
          var key_0 = get_NULL();
          var value_0 = get_NULL();
          mainLoop: while (true) {
            var idx = composite.j1s(this.b1n());
            switch (idx) {
              case -1:
                break mainLoop;
              case 0:
                key_0 = composite.f1s(this.b1n(), 0, this.u28_1);
                break;
              case 1:
                value_0 = composite.f1s(this.b1n(), 1, this.v28_1);
                break;
              default:
                throw SerializationException().w1o('Invalid index: ' + idx);
            }
          }
          if (key_0 === get_NULL())
            throw SerializationException().w1o("Element 'key' is missing");
          if (value_0 === get_NULL())
            throw SerializationException().w1o("Element 'value' is missing");
          tmp$ret$1 = this.t28(key_0, value_0);
        }
        var result = tmp$ret$1;
        composite.t1r(descriptor);
        return result;
      }
    }
    initMetadataForClass($, 'KeyValueSerializer', VOID, VOID, [KSerializer()]);
    KeyValueSerializerClass = $;
  }
  return KeyValueSerializerClass;
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
//region block: exports
export {
  MapEntrySerializer as MapEntrySerializer2ukwamih4zw76,
  PairSerializer as PairSerializerpzh6nuee9oov,
  TripleSerializer as TripleSerializer25andm5j3t9nu,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
